import { ButtonProps } from "../../../../types"
import { cn } from "../../../utils"

const Button = ({
  children,
  className = "",
  type = "button",
  disabled = false,
  paddingOff = false,
  onClick,
  href,
  target = "_blank",
  refProp,
  text = "sm",
  size = "base"
}: ButtonProps) => {
  const paddingClassName = {
    sm: "py-1 px-2",
    base: "py-3 px-4",
    md: "py-4 px-6",
    lg: "py-6 px-8"
  }

  const textClassName = {
    sm: "text-sm",
    base: "text-base",
    md: "text-md",
    lg: "text-lg"
  }

  const cls = cn(
    disabled ? "text-gray-400 pointer-events-none cursor-not-allowed" : "",
    "transition-colors relative inline-flex justify-center items-center border font-medium rounded-md focus:outline-none",
    textClassName[text],
    paddingOff ? "p-0" : paddingClassName[size],
    className
  )

  return !!href ? (
    <a href={href} className={cls} target={target}>
      {children}
    </a>
  ) : (
    <button
      ref={refProp}
      disabled={disabled}
      type={type}
      className={cls}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default Button
